import {
  // -- GET (list)
  GET_GLOBAL_PARAMETERS_SUCCESS,
  GET_GLOBAL_PARAMETERS_FAILURE,
  // -- CREATE
  CREATE_GLOBAL_PARAMETER_SUCCESS,
  CREATE_GLOBAL_PARAMETER_FAILURE,
  // -- UPDATE
  UPDATE_GLOBAL_PARAMETER_SUCCESS,
  UPDATE_GLOBAL_PARAMETER_FAILURE,
  // -- DELETE
  DELETE_GLOBAL_PARAMETER_SUCCESS,
  DELETE_GLOBAL_PARAMETER_FAILURE
} from '../../actions'
import { Logger, LoggerTypes } from '../../utils'

export const globalParameters = (state = {}, action) => {
  switch (action.type) {
    // -- GET GLOBAL PARAMETERS (list)
    case GET_GLOBAL_PARAMETERS_FAILURE: {
      Logger.trace(LoggerTypes.WARN, '[REDUCER] globalParameters.GET_GLOBAL_PARAMETERS_FAILURE()', { state, action })
      return { ...state, error: action.data }
    }
    case GET_GLOBAL_PARAMETERS_SUCCESS: {
      Logger.trace(LoggerTypes.REDUCER, '[REDUCER] globalParameters.GET_GLOBAL_PARAMETERS_SUCCESS()', { state, action })
      return {
        ...state,
        items: action.data
      }
    }

    // -- CREATE GLOBAL PARAMETER
    case CREATE_GLOBAL_PARAMETER_FAILURE: {
      Logger.trace(LoggerTypes.WARN, '[REDUCER] globalParameters.CREATE_GLOBAL_PARAMETER_FAILURE()', { state, action })
      return { ...state, error: action.data }
    }
    case CREATE_GLOBAL_PARAMETER_SUCCESS: {
      let newItems = [...state.items]
      newItems.push(action.data)

      Logger.trace(LoggerTypes.REDUCER, '[REDUCER] globalParameters.CREATE_GLOBAL_PARAMETER_SUCCESS()', {
        state,
        action,
        newItems
      })

      return {
        ...state,
        items: newItems
      }
    }

    // -- UPDATE GLOBAL PARAMETER
    case UPDATE_GLOBAL_PARAMETER_FAILURE: {
      Logger.trace(LoggerTypes.WARN, '[REDUCER] globalParameters.UPDATE_GLOBAL_PARAMETER_FAILURE()', { state, action })
      return { ...state, error: action.data }
    }
    case UPDATE_GLOBAL_PARAMETER_SUCCESS: {
      const newItems = state.items.map((obj) => [action.data].find((o) => o.id === obj.id) || obj)

      Logger.trace(LoggerTypes.REDUCER, '[REDUCER] globalParameters.UPDATE_GLOBAL_PARAMETER_SUCCESS()', {
        state,
        action,
        newItems
      })

      return {
        ...state,
        items: newItems
      }
    }

    // -- DELETE GLOBAL PARAMETER
    case DELETE_GLOBAL_PARAMETER_FAILURE: {
      Logger.trace(LoggerTypes.WARN, '[REDUCER] globalParameters.DELETE_GLOBAL_PARAMETER_FAILURE()', { state, action })
      return { ...state, error: action.data }
    }
    case DELETE_GLOBAL_PARAMETER_SUCCESS: {
      const newItems = state.items.filter((obj) => obj.id !== action.data)

      Logger.trace(LoggerTypes.REDUCER, '[REDUCER] globalParameters.DELETE_GLOBAL_PARAMETER_SUCCESS()', {
        state,
        action,
        newItems
      })

      return {
        ...state,
        items: newItems
      }
    }

    default:
      return state
  }
}
